import { render, staticRenderFns } from "./NICEPayResult.vue?vue&type=template&id=43de87a8&"
import script from "./NICEPayResult.vue?vue&type=script&lang=js&"
export * from "./NICEPayResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports